import React, { useCallback } from 'react'
import { CalendarOutlined, UnorderedListOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'
import Ntf from './ntf'

const NavigationButtons = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  @media (max-width: 768px) {
    gap: 8px;
  }
`

const NavigationButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s, border-color 0.3s;
  background-color: #f4dfad;
  border: 1px solid #dfc077;
  border-radius: 8px;
  width: 40px;
  height: 40px;

  &:hover {
    color: #596b76;
    background-color: #efd28e;
    border-color: #d4ad51;
  }

  svg {
    width: 16px;
  }

  @media (max-width: 768px) {
    width: 48px;
  }
`

const NavigationButtonIcon = styled.span`
  font-size: 20px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`

export const TopMenu = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const isCalendarPage = location.pathname === '/tasks/calendar'

  const handleNewCalendarClick = useCallback(() => {
    navigate(isCalendarPage ? '/tasks' : '/tasks/calendar')
  }, [navigate, isCalendarPage])

  return (
    <NavigationButtons>
      <Ntf />
      <NavigationButton onClick={handleNewCalendarClick}>
        <NavigationButtonIcon>
          {isCalendarPage ? <UnorderedListOutlined /> : <CalendarOutlined />}
        </NavigationButtonIcon>
      </NavigationButton>
    </NavigationButtons>
  )
}
